package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.AccordionDemo

@Page
@Composable
fun AccordionPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/accordion.md", mapOf("title" to listOf("Accordion"), "description" to listOf("A vertically stacked set of interactive headings that each reveal a section of content."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/accordion"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/accordion#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Accordion
import shadcn.ui.components.AccordionContent
import shadcn.ui.components.AccordionItem
import shadcn.ui.components.AccordionTrigger
import web.cssom.ClassName

val AccordionDemo = FC<Props> {
    Accordion {
        type = "single"
        collapsible = true
        className = ClassName("w-full")
        AccordionItem {
            value ="item-1"
            AccordionTrigger {
                +"Is it accessible?"
            }
            AccordionContent {
                +"Yes. It adheres to the WAI-ARIA design pattern."
            }
        }
        AccordionItem {
            value ="item-2"
            AccordionTrigger {
                +"Is it styled?"
            }
            AccordionContent {
                +" Yes. It comes with default styles that matches the other components aesthetic."
            }
        }
        AccordionItem {
            value ="item-3"
            AccordionTrigger {
                +"Is it animated?"
            }
            AccordionContent {
                +"Yes. It's animated by default, but you can disable it if you prefer."
            }
        }
    }
}
"""){ 
 AccordionDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Accordion
import shadcn.ui.components.AccordionContent
import shadcn.ui.components.AccordionItem
import shadcn.ui.components.AccordionTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""Accordion {
    type = "single"
    collapsible = true
    AccordionItem {
        value = "item-1"
        AccordionTrigger {
            +"Is it accessible?"
        }
        AccordionContent {
            +"Yes. It adheres to the WAI-ARIA design pattern."
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
